export function splitTime(date) {
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return [hour, minute, second];
}

export function composeTime(hour, minute, second) {
  if (hour >= 20) hour = 20;
  if (hour <= 0) hour = 0;
  if (hour === 0 && minute === 0 && second <= 0) second = 0;
  return new Date(2000, 0, 1, hour, minute, second);
}

export function timerFinished(date) {
  const [hour, minute, second] = splitTime(date);
  if (hour <= 0 && minute <= 0 && second <= 0) return true;
  else return false;
}

export const EMPTY_TIME = new Date(2000, 0, 1, 0, 0, 0);
